import { render, staticRenderFns } from "./AudienceFeature.vue?vue&type=template&id=a1e72268&scoped=true"
import script from "./AudienceFeature.vue?vue&type=script&lang=js"
export * from "./AudienceFeature.vue?vue&type=script&lang=js"
import style0 from "./AudienceFeature.vue?vue&type=style&index=0&id=a1e72268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e72268",
  null
  
)

export default component.exports